module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/trending-up-light.16634e15.svg";